export default [
  {label: "AGRICULTURE", value: "A001"},
  {label: "BUSINESS&PROFESSIONAL(OFFICE)", value: "A002"},
  {label: "CHEMICAL & PHARMACEUTICAL", value: "A003"},
  {label: "CONSTRUCTION", value: "A004"},
  {label: "EDUCATION & TRAINING", value: "A005"},
  {label: "ELECTRICAL & ELECTRONICS", value: "A006"},
  {label: "ENTERTAINMENT", value: "A007"},
  {label: "FOOD & BEVERAGE", value: "A008"},
  {label: "GENERAL STORAGE", value: "A009"},
  {label: "HEALTHCARE", value: "A010"},
  {label: "HOSPITALITY & TOURISM", value: "A011"},
  {label: "MANUFACTURING", value: "A012"},
  {label: "MINING AND QUARRYING", value: "A013"},
  {label: "MOTOR TRADE AND RELATED RISKS", value: "A014"},
  {label: "PAPER AND PRINTING", value: "A015"},
  {label: "PETROLEUM/UTILITIES", value: "A016"},
  {label: "RESIDENTIAL/HOTEL", value: "A017"},
  {label: "RETAIL TRADING", value: "A018"},
  {label: "TELECOMMUNICATION", value: "A019"},
  {label: "TEXTILE/APPARELS/LEATHER/FIBRE", value: "A020"},
  {label: "TIMBER RELATED", value: "A021"},
  {label: "TRANSPORTATION & LOGISTICS", value: "A022"},
  {label: "TRADING ", value: "A023"}
]